import React, { useState, useEffect } from "react";
import {
  Button,
  OutlinedInput,
  Pagination,
  Typography,
  Stack,
  Box,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
} from "@mui/material";
import Draggable from "react-draggable";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import moment from "moment";
import { ArrowsCounterClockwise } from "@phosphor-icons/react";
import { toast } from "react-toastify";
import { Hourglass } from "react-loader-spinner";
import { FaEye } from "react-icons/fa";
import { toaststyle } from "../../Utils/toaststyle";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import { connect } from "react-redux";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";
import { getAvailableAgentList } from "../../Redux/Actions/actions";
const mapStateToProps = (state) => {
  return {
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const QueueChat = (props) => {
  const [queueList, setqueueList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [selectedAgents, setSelectedAgents] = useState({});
  const [spinner, setspinner] = useState(false);
  const [scriptUrl, setOpenScriptUrl] = useState(false);
  const [scriptUrlVal, setScriptUrlVal] = React.useState("");

  const handleOpenScriptUrl = (url) => {
    setScriptUrlVal(url);
    setOpenScriptUrl(true);
  };

  const handleCloseScriptUrl = () => {
    setOpenScriptUrl(false);
  };

  const QueueChatAPi = (value) => {
    if (!value) {
      setspinner(true);
    }
    axios
      .post(
        BaseUrl + "/users/listqueuedsession",
        {
          limit: 10,
          offset: page == 1 ? 0 : (page - 1) * 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setspinner(true);
        if (res.data.status) {
          setqueueList(res.data.data);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        } else {
          setqueueList([]);
          setPagination(0);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner(false);
        }, 1500);
      });
  };

  const updateAgent = async (value, value2) => {
    await axios
      .post(
        BaseUrl + "/users/updateAgent",
        {
          chat_session_id: value,
          agentId: value2,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          let newValue = queueList.filter(
            (item) => item.chat_session_id != value
          );
          if (newValue.length == 0) {
            if (page == 1) {
              setPage(1);
              setqueueList(newValue);
            } else {
              setPage(page - 1);
              setqueueList(newValue);
            }
          } else {
            setqueueList(newValue);
          }
          toast.success("Assign To Agent", toaststyle);
        } else {
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((err) => {
        setShow(true);
      });
  };
  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    props.getAvailableAgentList();
    QueueChatAPi();
  }, [page]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      QueueChatAPi("noSpinner");
    }, 60000);
    return () => clearInterval(intervalId);
  }, [page]);
  return (
    // QUEUE CHAT start
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Queue Chat
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/* Refresh btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.getAvailableAgentList();
                  QueueChatAPi();
                  setspinner("spin 1s infinite");
                }}
              >
                <ArrowsCounterClockwise className="me-2" />
                Refresh
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table">
                <StyledTableHead>
                  <StyledTableRow>
                    {[
                      "Name",
                      "Phone Number",
                      "Email",
                      "Channel",
                      "Skillset",
                      "Arrival At",
                      "Assign To",
                      "Action",
                    ].map((headers) => (
                      <StyledTableCell>{headers}</StyledTableCell>
                    ))}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  {spinner ? (
                    <Stack
                      sx={{ position: "absolute", top: "50%", left: "50%" }}
                    >
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) : queueList.length > 0 ? (
                    queueList.map((item, rowIndex) => (
                      <StyledTableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={rowIndex}
                      >
                        <StyledTableCell2>
                          {item.unique_id && item.unique_id.username
                            ? item.unique_id.username
                            : ""}
                        </StyledTableCell2>
                        <StyledTableCell2>{item.phonenumber}</StyledTableCell2>
                        <StyledTableCell2>{item.email}</StyledTableCell2>
                        <StyledTableCell2>{item.channel}</StyledTableCell2>
                        <StyledTableCell2>{item.skillset}</StyledTableCell2>
                        <StyledTableCell2>
                          {moment(item.createdAt).format("L hh:mm:ss A")}
                        </StyledTableCell2>

                        <StyledTableCell2 style={{ width: 140 }}>
                          <FormControl sx={{ width: 180 }} size="small">
                            <InputLabel
                              id={`select-agent-label-${item.chat_session_id}`}
                            >
                              Select Agent
                            </InputLabel>
                            <Select
                              labelId={`select-agent-label-${item.chat_session_id}`}
                              id={`select-agent-${item.chat_session_id}`}
                              value={selectedAgents[item.chat_session_id] || ""}
                              onChange={(event) => {
                                const { value } = event.target;
                                setSelectedAgents((prevState) => ({
                                  ...prevState,
                                  [item.chat_session_id]: value,
                                }));
                                updateAgent(item.chat_session_id, value);
                              }}
                              input={<OutlinedInput label="Select Agent" />}
                              MenuProps={{
                                style: {
                                  top: "0px",
                                  maxHeight: "350px",
                                },
                              }}
                            >
                              {props.DropDownAgentList.length > 0 ? (
                                props.DropDownAgentList.map((agent) => (
                                  <MenuItem
                                    value={agent.user_id}
                                    key={agent.user_id}
                                  >
                                    {agent.username}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem>{"No Data"}</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </StyledTableCell2>
                        <StyledTableCell2 className="text-center">
                          {item.channel == "from_purple" ? (
                            <Typography
                              sx={{
                                cursor: "pointer",
                                width: "30px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "5px",
                                ":hover": {
                                  backgroundColor: "#e9e9e9",
                                  transform: "scale(1.1)",
                                  transition: "transform 0.2s",
                                },
                              }}
                              onClick={() =>
                                handleOpenScriptUrl(item.transcripturl)
                              }
                            >
                              <FaEye size={13} color="#1976d2" />
                            </Typography>
                          ) : (
                            "--"
                          )}
                        </StyledTableCell2>
                      </StyledTableRow>
                    ))
                  ) : (
                    // Data unavailable start
                    <Stack
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "calc(100vh - 14rem)",
                      }}
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Stack
                        className="text-muted"
                        direction="column"
                        justifyContent="center"
                        alignContent="center"
                      >
                        <span className="mx-auto">
                          <img
                            src={Nodata}
                            alt="pic"
                            style={{ width: "11rem", userSelect: "none" }}
                          />
                        </span>
                        <span className="mx-auto">
                          <h6
                            className="text-muted mt-3"
                            style={{ fontSize: "13px" }}
                          >
                            Data unavailable
                          </h6>
                        </span>
                      </Stack>
                    </Stack>
                    // Data unavailable end
                  )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                {Math.min(page * 10, pagination)} of {pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>
      <Dialog
        open={scriptUrl}
        onClose={handleCloseScriptUrl}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          ChatBot Transcript
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <iframe
              src={scriptUrlVal}
              title="External Content"
              width="100%"
              height="500px"
              style={{ border: "none" }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseScriptUrl}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </StyledPaper>

    // QUEUE CHAT end
  );
};

export default connect(mapStateToProps, {
  getAvailableAgentList,
})(QueueChat);
